import { HubLandingPage } from '../../../../../../types';
import { useRootSelector } from '../../../../../../store/hooks';
import {
  selectBrandHubPage,
  selectBrandHubPageLogo,
} from '../../../store/features/page';
import { selectBrandHubOptions } from '../../../store/features/options';
import PageLayout from '../../../layouts/PageLayout';
import { MetaTags } from '../../../../shared/MetaTags';
import { HubModuleBuilder } from '../../../../shared/siteBuilder/HubModuleBuilder';
import ErrorBoundary from '../../../../../common/ErrorBoundary';
import { InformaMetaTagPageType } from '../../../../../../constants';

export default function Page() {
  const {
    data: {
      landingPage: {
        id,
        modules = [],
        details: { name: pageName, title, metaDescription },
      },
      header: {
        headerNavBar: { brandLogo },
      },
    },
  } = useRootSelector(selectBrandHubPage<HubLandingPage>());
  const {
    data: { name: hubName },
  } = useRootSelector(selectBrandHubOptions);
  const pageLogo = useRootSelector(selectBrandHubPageLogo);

  const logo = pageLogo ?? brandLogo;
  const heading = title || pageName;

  return (
    <PageLayout>
      <MetaTags
        informaPageType={InformaMetaTagPageType.LandingPage}
        informaPageId={id}
        thumbnail={logo?.path}
        description={metaDescription}
        titleSuffix={hubName}
        title={heading}
      />
      {modules.map((module, index) => (
        <ErrorBoundary key={index}>
          <HubModuleBuilder module={module} />
        </ErrorBoundary>
      ))}
    </PageLayout>
  );
}
